import { Component, Host, h, Prop } from '@stencil/core';
import type { CssClassMap } from '../../helpers/utils/interfaces';

@Component({
  tag: 'cms-labeled-link',
  styleUrl: 'cms-labeled-link.scss',
  shadow: true,
})
export class CmsLabeledLink {
  /**
   * set the target url ref
   */
  @Prop({ mutable: true }) url: string;

  /**
   * set the container Label like Material- und Werkzeugliste
   */
  @Prop({ mutable: true }) label: string;

  /**
   * set the Button Label like Download
   */
  @Prop({ mutable: true }) buttonText: string;

  /**
   * set the icon to be shown
   */
  @Prop({ mutable: true }) icon?: string;

  /**
   * set the target window (optional) - default: _self
   */
  @Prop({ mutable: true }) target?: '_self' | '_top' = '_self';

  /**
   * Set  Layout full 100% or two-thirds 66%
   */
  @Prop({ mutable: true }) layout: 'full' | 'two-thirds' | 'half';

  /**
   * set the tracking parameter event type
   */
  @Prop({ mutable: true }) dataEventtype: string | undefined;

  /**
   * set the tracking parameter event
   */
  @Prop({ mutable: true }) dataEvent: string | undefined;

  /**
   * set the tracking parameter uid
   */
  @Prop({ mutable: true }) dataUid: string | undefined;

  /**
   * set, if this component is used standalone or within a section
   */
  @Prop({ mutable: true }) standalone?: false;

  /**
   * set, if this component provides a file that is downloadeable
   */
  @Prop({ mutable: true }) download?: false;

  /**
   * Set the rel-value for the cta
   */
  @Prop() rel = 'noopener follow';

  private containerCssClassMap(): CssClassMap {
    return {
      'cms-labeled-link': true,
      [this.layout]: true,
      standalone: this.standalone,
    };
  }

  render() {
    const tagAttributes = {
      class: 'cms-labeled-link-anchor',
      href: this.url,
      rel: this.rel,
      target: this.target,
      label: this.buttonText,
      'tag-title': this.label,
      dataEventtype: this.dataEventtype,
      dataEvent: this.dataEvent,
      dataUid: this.dataUid,
    } as LabeledLinkAttributes;

    if (this.download) {
      tagAttributes.download = this.label;
    }
    return (
      <Host class={this.containerCssClassMap()}>
        {this.url !== undefined ? (
          <div class={'cms-labeled-link-inner'}>
            <div class={'label-wrapper'}>
              {this.icon && (
                <span class={'svg-wrapper'}>
                  <cms-icon size='xl' icon={this.icon} />
                </span>
              )}
              <span class={'cms-labeled-link-label'}>{this.label}</span>
            </div>
            <div class={'button-wrapper'}>
              <cms-button
                {...tagAttributes}
                theme='secondary'
                size='button-md'
              />
            </div>
          </div>
        ) : null}
      </Host>
    );
  }
}
interface LabeledLinkAttributes {
  class: string;
  href: string;
  rel: string;
  target: '_self' | '_top' | '_blank' | '_parent';
  label: string;
  'tag-title': string;
  dataEventtype: string;
  dataEvent: string;
  dataUid: string;
  download?: string;
}
